export enum ApplicationStatus {
  EXCLUDED = 'E',
  DOCUMENTATION_COMPLETED = 'DC',
  APPLIED = 'P',
  SUBSANATION = 'S'
}
